// Imports fotos Desktop
import AllNewK3 from "../assets/img/inicio/homeSlider/desktop/All-new K3.webp";
import AllNewK3Cross from "../assets/img/inicio/homeSlider/desktop/All-new K3 Cross.webp";
import AllNewK3Sedan from "../assets/img/inicio/homeSlider/desktop/All-new K3 Sedan.webp";
import Carnival from "../assets/img/inicio/homeSlider/desktop/Carnival.webp";
import Sportage from "../assets/img/inicio/homeSlider/desktop/Sportage nuevo.webp";
import Seltos from "../assets/img/inicio/homeSlider/desktop/Seltos.webp";
import K2500 from "../assets/img/inicio/homeSlider/desktop/K2500.webp";

//Imports fotos Mobile
import AllNewK3Mobile from "../assets/img/inicio/homeSlider/mobile/All-new K3 Mobile.webp";
import AllNewK3CrossMobile from "../assets/img/inicio/homeSlider/mobile/All-new K3 Cross Mobile.webp";
import AllNewK3SedanMobile from "../assets/img/inicio/homeSlider/mobile/All-new K3 Sedan Mobile.webp";
import CarnivalMobile from "../assets/img/inicio/homeSlider/mobile/Carnival Mobile.webp";
import SportageMobile from "../assets/img/inicio/homeSlider/mobile/Sportage Mobile.webp";
import SeltosMobile from "../assets/img/inicio/homeSlider/mobile/Seltos Mobile.webp";
import K2500Mobile from "../assets/img/inicio/homeSlider/mobile/K2500 Mobile.webp";

// Este archivo contiene los datos para el slider
export const homeSlider = [
  {
    imagen: AllNewK3,
    imagenMobile: AllNewK3Mobile,
    titulo: "All-new K3",
    subtitulo: "Más allá de lo posible",
    textoBoton: "Lo quiero",
    linkBoton: "https://reservak3.kia.com.ar/ess",
    target: "_blank",
    esExterna: true,
  },
  {
    imagen: AllNewK3Cross,
    imagenMobile: AllNewK3CrossMobile,
    titulo: "All-new K3 Cross",
    subtitulo: "Más allá de lo posible",
    textoBoton: "Conocer más",
    linkBoton: "/k3-cross",
    target: "",
    esExterna: false,
  },
  {
    imagen: AllNewK3Sedan,
    imagenMobile: AllNewK3SedanMobile,
    titulo: "All-new K3 Sedán",
    subtitulo: "Más allá de lo posible",
    textoBoton: "Conocer más",
    linkBoton: "/k3-sedan",
    target: "",
    esExterna: false,
  },
  {
    imagen: Carnival,
    imagenMobile: CarnivalMobile,
    titulo: "Carnival",
    subtitulo: "Amplia tus horizontes",
    textoBoton: "Conocer más",
    linkBoton: "/carnival",
    target: "",
    esExterna: false,
  },
  {
    imagen: Sportage,
    imagenMobile: SportageMobile,
    titulo: "Nueva Sportage",
    subtitulo: "Inspiración sin límites",
    textoBoton: "Conocer más",
    linkBoton: "/sportage",
    target: "",
    esExterna: false,
  },
  {
    imagen: Seltos,
    imagenMobile: SeltosMobile,
    titulo: "Seltos",
    subtitulo: "Que nada te detenga",
    textoBoton: "Conocer más",
    linkBoton: "/seltos",
    target: "",
    esExterna: false,
  },
  {
    imagen: K2500,
    imagenMobile: K2500Mobile,
    titulo: "K2500",
    subtitulo: "A la medida de tu negocio",
    textoBoton: "Conocer más",
    linkBoton: "/k2500",
    target: "",
    esExterna: false,
  },
];
